import {
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  Stack,
  ModalFooter,
  Flex,
} from '@tonic-one/react';
import { CorrelatedExpressionShallow } from '../types';
import { FormLabel } from '@Components/Common/FormComponent';
import { useTranslation } from 'react-i18next';

const PreDefinedExpressionModal = (props: {
  expression: CorrelatedExpressionShallow;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { expression, isOpen, onClose } = props;
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      closeOnEsc
      closeOnOutsideClick
      isClosable
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>
          {t('globalSetting.correlatedExpressions.preDefinedModal.title')}
        </ModalHeader>
        <ModalBody>
          <Stack gap="4x">
            <Text size="lg">
              {t(
                'globalSetting.correlatedRules.preDefinedModal.basicProperties'
              )}
            </Text>
            <Flex alignItems="center">
              <FormLabel
                label={t('globalSetting.correlatedRules.preDefinedModal.name')}
              />
              <Text>{expression.raiExpName}</Text>
            </Flex>
            <Flex>
              <FormLabel
                label={t(
                  'globalSetting.correlatedRules.preDefinedModal.description'
                )}
              />
              <Text height="max-content" my="auto">
                {expression.raiExpDesc}
              </Text>
            </Flex>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>{t('common.button.close')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PreDefinedExpressionModal;
